import { useMemo } from 'react';
import { customFieldsApi } from 'apis/customFields';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
/**
 * A hook for determining whether custom attributes of an entity have required
 * attributes.
 */
export function useHasRequiredAttributes({ entityId, }) {
    const { requiredCustomAttribute } = useFeatureFlag([
        'required-custom-attribute',
    ]);
    const { currentData } = customFieldsApi.useReadAttributesQuery({
        entityId,
    });
    return useMemo(() => {
        return (requiredCustomAttribute &&
            !!(currentData === null || currentData === void 0 ? void 0 : currentData.data.attributes.some(({ is_required, is_archived, is_deactivated }) => is_required && !is_archived && !is_deactivated)));
    }, [currentData === null || currentData === void 0 ? void 0 : currentData.data.attributes, requiredCustomAttribute]);
}
